var React = require('react');

function Delay (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Assets","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"id":"image/delay","stroke":"#AB4040","strokeWidth":"2"},React.createElement("g",{"id":"Group-6","transform":"translate(2.000000, 2.000000)"},[React.createElement("path",{"d":"M32,16 L32,16 C32,24.836556 24.836556,32 16,32 L16,32 C7.163444,32 1.082166e-15,24.836556 0,16 L0,16 C-1.082166e-15,7.163444 7.163444,1.623249e-15 16,0 L16,0 C24.836556,-1.623249e-15 32,7.163444 32,16 Z","id":"Rectangle-314","fill":"#F28080","key":0}),React.createElement("polyline",{"id":"Path-2","points":"16.257203 5.40931905 16.257203 17.1998847 21.0228544 21.9655361","key":1})]))));
}

Delay.defaultProps = {"width":"36px","height":"36px","viewBox":"0 0 36 36"};

module.exports = Delay;

Delay.default = Delay;
